
/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Retail {

    import fld = GiftVoucherSalesReceiptRow.Fields;

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesReceiptEditor extends Common.GridEditorBase<GiftVoucherSalesReceiptRow> {
        protected getColumnsKey() { return "Retail.GiftVoucherSalesReceipt"; }
        protected getDialogType() { return GiftVoucherSalesReceiptDialog; }
        protected getLocalTextPrefix() { return GiftVoucherSalesReceiptRow.localTextPrefix; }
        protected form: GiftVoucherSalesReceiptForm;

        private pendingChanges: Q.Dictionary<any> = {};

        public CustomerId;
        public TotalItems: number;
        cont: JQuery;


        constructor(container: JQuery) {
            super(container);

        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        protected getButtons() {
            let buttons = super.getButtons();

            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            addbutton.hotkey = 'alt+r';
            addbutton.title = 'Add Receipt';
            /*

            buttons.push({
                title: "Credit Note",
                cssClass: "add-button",
                hotkey: "alt+c",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    if (this.CustomerId == 0 || this.CustomerId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        var grid = POSReturnSelectGrid;
                        POSReturnSelectGrid.CustomerId = this.CustomerId;

                        var pickerDialog = new _Ext.GridItemPickerDialog({

                            gridType: grid, multiple: true, title: 'Select Credit Note'

                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefNo == t.RefNo) });
                        var self = this;
                        var details = [];

                        selectedItems2.forEach(function (value: POSReturnRow) {
                            var code = OMS.PaymentModeRow.getLookup().itemById[8].Code;
                            var Receipt: GiftVoucherSalesReceiptRow = {
                                LedgerId: value.PartyId,
                                ModeId: 8,
                                Code: code,
                                Amount: value.GrossAmount,
                                RefNo: value.VoucherNo,
                                RefVoucherType: value.VoucherTypeId,
                                RefTransId: value.TransId
                            };
                            details.push(Receipt);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.Id)) {
                                this.view.addItem(Detail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.push({
                title: "Exchange",
                cssClass: "add-button",
                hotkey: "alt+e",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    if (this.CustomerId == 0 || this.CustomerId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        var grid = ExchangeSelectGrid;
                        ExchangeSelectGrid.CustomerId = this.CustomerId;

                        var pickerDialog = new _Ext.GridItemPickerDialog({

                            gridType: grid, multiple: true, title: 'Select Exchange Note'

                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefNo == t.RefNo) });
                        var self = this;
                        var details = [];

                        selectedItems2.forEach(function (value: POSReturnRow) {
                            var code = OMS.PaymentModeRow.getLookup().itemById[9].Code;
                            var Receipt: GiftVoucherSalesReceiptRow = {
                                LedgerId: value.PartyId,
                                ModeId: 9,
                                Code: code,
                                Amount: value.GrossAmount,
                                RefNo: value.VoucherNo,
                                RefVoucherType: value.VoucherTypeId,
                                RefTransId: value.TransId
                            };
                            details.push(Receipt);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.Id)) {
                                this.view.addItem(Detail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });
            

*/

            return buttons;
        }

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        validateEntity(row: GiftVoucherSalesReceiptRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;

            row.ModeId = Q.toId(row.ModeId);
            if (row.ModeId == 3) {
                var sameProduct = Q.tryFirst(this.view.getItems(), x => x.ModeId === row.ModeId);
                if (sameProduct && this.id(sameProduct) !== id) {
                    Q.alert('This Mode of payment is already added!');
                    return false;
                }
            } else if (row.ModeId == 8 || row.ModeId == 9) {
                var sameProduct = Q.tryFirst(this.view.getItems(), x => x.RefTransId === row.RefTransId && x.RefVoucherType === row.RefVoucherType);
                if (sameProduct && this.id(sameProduct) !== id) {
                    Q.alert('This Mode of payment is already added!');
                    return false;
                }
            }
            row.Code = OMS.PaymentModeRow.getLookup().itemById[row.ModeId].Code;

            return true;
        }

    }
}